import { useEffect, useState } from "react"

import { Alert, App, Flex, Segmented, Spin, Switch, Typography } from "antd"
import { connect } from "react-redux"

import ButtonComponent from "../../Components/Button"
import InputNumberComponent from "../../Components/Input/InputNumber"
import Private from "../../Components/Private"
import SelectComponent from "../../Components/Select"
import { modalConfig } from "../../theme"
import PricingActions from "../PricingPage/reducer"
import { userActions } from "../User/redux/user.slice"
import { updateUserPrice } from "../User/redux/user.thunks"
import TitleSection from "./components/TitleSection"

const { Text } = Typography

const levelsType = [
  { id: "ethoca_price_levels", label: "Ethoca price levels" },
  { id: "rdr_1_price_levels", label: "RDR price" },
  { id: "cdrn_price_levels", label: "CDRN price" }
]
const FormList = ({ label, data, count_of_free_alerts }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        rowGap: 8
      }}
    >
      <Text>{label}</Text>
      {data.map((level, index) => (
        <Flex gap={8} key={level.id} style={{ marginBottom: 0 }}>
          <InputNumberComponent
            size="small"
            placeholder={"Range from"}
            disabled={true}
            value={index ? data?.[index - 1]?.["range_to"] + 1 : (count_of_free_alerts || 0) + 1}
            style={{ width: 100 }}
          />

          <InputNumberComponent
            size="small"
            placeholder={"Range to"}
            disabled={true}
            value={level?.range_to}
            style={{ width: 100 }}
          />

          <InputNumberComponent
            size="small"
            prefix="$"
            precision={2}
            disabled={true}
            value={level?.price}
            style={{ flex: "auto" }}
          />
        </Flex>
      ))}
    </div>
  )
}

const Pricing = ({ isMobile, businessAccount, fetching, pricing, saveFetching, ...props }) => {
  const { modal } = App.useApp()
  const [newPrice, setNewPrice] = useState(null)
  const [priceData, setPriceData] = useState({})

  useEffect(() => {
    props.resetPricingLoadingState()
    props.userSaveResultReset()
    props.getPricing({ all: true })
  }, [])

  useEffect(() => {
    if (businessAccount?.pricing) setNewPrice(businessAccount?.pricing)
  }, [businessAccount])

  useEffect(() => {
    if (pricing.length && newPrice) {
      let newPriceData = pricing?.filter((el) => el.id === newPrice)?.[0]
      setPriceData(newPriceData)
    }
  }, [pricing, newPrice])

  const optionsSchemaFinal = pricing?.map((price) => ({
    value: price?.id,
    label: price?.pricing_schema
  }))

  const handleChangeSchema = (value) => {
    setNewPrice(value)
  }

  const handleUpdateUserPrice = () => {
    if (businessAccount?.pricing === newPrice) return
    modal.confirm({
      ...modalConfig("exclamation"),
      centered: !isMobile,

      title: "Save pricing settings",
      content:
        "Are you sure you want to save and apply these prices? If you proceed, new pricing scheme and prices will be applied for all alerts in the next invoice for this business account.",

      cancelText: "Cancel",
      okText: "Save and apply",
      onOk() {
        props.updateUserPrice({ ba_id: businessAccount.id, pricing: newPrice })
      },
      onCancel() {
        console.log("Cancel")
      }
    })
  }

  return (
    <div style={{ paddingBottom: "24px" }}>
      <TitleSection
        title={
          <>
            {"Pricing for "}
            <Private>{businessAccount?.name}</Private>
          </>
        }
        link={businessAccount?.url}
      />

      <Spin size="large" spinning={fetching || saveFetching}>
        <Flex vertical={true} gap={30} style={{ maxWidth: 420, width: "40%", minWidth: 320 }}>
          <Flex gap={24} style={{ padding: 3 }}>
            <SelectComponent
              defaultValue={priceData?.["pricing_schema"]}
              value={newPrice}
              placeholder="Select a pricing scheme type"
              onChange={handleChangeSchema}
              options={optionsSchemaFinal}
              className={"like-input"}
              style={{ width: "100%" }}
            />

            <ButtonComponent href={"/pricing"}>Edit</ButtonComponent>
          </Flex>

          <Segmented
            options={["Fixed", "Volume based"]}
            name="type"
            size="large"
            block
            value={priceData?.["type"]}
            disabled={true}
            style={{ fontWeight: 500 }}
          />

          <Alert
            type="info"
            icon={
              <Switch
                defaultChecked={priceData?.["is_applied_from_scratch"]}
                checked={priceData?.["is_applied_from_scratch"]}
                disabled={true}
                onChange={() => {}}
              />
            }
            message={<Text strong>Prices listed below are applied from scratch</Text>}
            description={
              <Text type="secondary">
                The next received alert will be considered as the first alert in the volume
              </Text>
            }
            showIcon
          />

          <Flex gap={24} align="center">
            <Text style={{ minWidth: 136 }}>Number of the first alerts to skip</Text>
            <InputNumberComponent
              size="small"
              value={priceData?.["count_of_free_alerts"]}
              disabled={true}
              style={{ width: 80 }}
            />
          </Flex>

          {priceData?.["type"] === "Volume based" ? (
            levelsType.map(({ id, label }) => (
              <FormList
                id={id}
                key={id}
                label={label}
                data={priceData?.[id]}
                count_of_free_alerts={priceData?.["count_of_free_alerts"]}
              />
            ))
          ) : (
            <>
              <Flex gap={24} align="center">
                <Text style={{ minWidth: 136 }}>Ethoca price ($)</Text>
                <InputNumberComponent
                  size="small"
                  precision={2}
                  value={priceData?.["ethoca_price"]}
                  disabled={true}
                  style={{ width: 80 }}
                />
              </Flex>

              <Flex gap={24} align="center">
                <Text style={{ minWidth: 136 }}>RDR price ($)</Text>
                <InputNumberComponent
                  size="small"
                  precision={2}
                  value={priceData?.["rdr_1_price"]}
                  disabled={true}
                  style={{ width: 80 }}
                />
              </Flex>

              <Flex gap={24} align="center">
                <Text style={{ minWidth: 136 }}>CDRN price ($)</Text>
                <InputNumberComponent
                  size="small"
                  precision={2}
                  value={priceData?.["cdrn_price"]}
                  disabled={true}
                  style={{ width: 80 }}
                />
              </Flex>
            </>
          )}
        </Flex>

        <Flex gap={16} justify="end" style={{ marginTop: 5, padding: "0 3px 3px 3px" }}>
          <ButtonComponent
            size="large"
            type="primary"
            disabled={businessAccount?.pricing === newPrice}
            onClick={handleUpdateUserPrice}
          >
            Save and apply pricing
          </ButtonComponent>
        </Flex>
      </Spin>
    </div>
  )
}
const mapStateToProps = (state) => ({
  isMobile: state.nav.isMobile,
  businessAccount: state.user.businessAccount,

  saveFetching: state.user.saveFetching,
  saveResult: state.user.saveResult,

  fetching: state.pricing.fetching,
  pricing: state.pricing.result.results
})

const mapDispatchToProps = (dispatch) => ({
  getPricing: (params) => dispatch(PricingActions.getPricingRequest(params)),
  updateUserPrice: (data) => dispatch(updateUserPrice(data)),
  resetPricingLoadingState: () => {
    dispatch(PricingActions.pricingSetProp("fetching", false))
    dispatch(PricingActions.pricingSetProp("saveFetching", false))
    dispatch(PricingActions.pricingSetProp("exportFetching", false))
  },
  userSaveResultReset: () => dispatch(userActions.userSaveResultReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(Pricing)
